// @ts-expect-error
import NimblePicker from 'emoji-mart/dist/components/picker/nimble-picker';

export { NimblePicker as default };
